{
  "AllNotifications": "すべての通知",
  "NoLinkNotification": "この通知に利用可能なリンクはありません",
  "ViewAllAnnouncementTab": "お知らせ",
  "ViewallNotificationTab": "通知",
  "preferences": "環境設定を編集"
}
